export default __webpack_public_path__ + "static/media/it_3.0ee648eb.mp3";